export default "__VITE_ASSET__697db501__"